"use strict";
/* tslint:disable */
var load_themed_styles_1 = require('@microsoft/load-themed-styles');
load_themed_styles_1.loadStyles([{ "rawString": ".ms-Facepile{position:relative;height:32px;width:auto}.ms-Facepile-itemBtn{position:relative;height:32px;width:32px;line-height:32px;text-align:center;padding:0;outline:transparent;border-radius:50%;vertical-align:top}html[dir=ltr] .ms-Facepile-itemBtn{float:left}html[dir=rtl] .ms-Facepile-itemBtn{float:right}html[dir=ltr] .ms-Facepile-itemBtn{margin-right:4px}html[dir=rtl] .ms-Facepile-itemBtn{margin-left:4px}button.ms-Facepile-itemBtn{display:inline;background:0 0;padding:0;cursor:pointer;border:none}" }]);
/* tslint:enable */

//# sourceMappingURL=Facepile.scss.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Facepile/Facepile.scss.js
 ** module id = 192
 ** module chunks = 0
 **/